import React, { useEffect, useState } from "react";
import { Table } from "antd";
import Papa from "papaparse";
import ClusterModal from "./ClusterModal";

const ClusterTable = ({
  currentPage,
  pageSize,
  totalRecord,
  totalPage,
  setCurrentPage,
  title,
}) => {
  const [filteredData, setFilteredData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedACID, setSelectedACID] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const fetchCSVData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch("/all_data.csv");
        const text = await response.text();

        Papa.parse(text, {
          header: true,
          worker: true,
          skipEmptyLines: true,
          complete: (results) => {
            const parsedData = results.data;
            if (!Array.isArray(parsedData) || parsedData.length === 0) {
              console.error("Parsed data is not valid or empty:", parsedData);
              setIsLoading(false);
              return;
            }

            const processedData = parsedData.map((row) => {
              const rowData = {
                AC_ID: row.AC_ID,
                CLUSTER_VALUE: row.out,
              };

              Object.keys(row)
                .filter((key) => key.startsWith("CONS_"))
                .forEach((key) => {
                  const cleanKey = key.replace("CONS_", "");
                  rowData[cleanKey] = row[key];
                });

              return rowData;
            });

            setFilteredData(processedData);

            const cols = [
              {
                title: "AC_ID",
                dataIndex: "AC_ID",
                key: "CLUSTER",
                width: 150,
                sorter: (a, b) => Number(a.AC_ID) - Number(b.AC_ID),
                render: (text) => (
                  <a onClick={() => handleRowClick(text)}>{text}</a>
                ),
              },
              {
                title: "Cluster",
                dataIndex: "CLUSTER_VALUE",
                key: "CLUSTER_VALUE",
                width: 150,
                sorter: (a, b) =>
                  Number(a.CLUSTER_VALUE) - Number(b.CLUSTER_VALUE),
              },
              ...Object.keys(processedData[0])
                .filter((key) => /^\d{6}$/.test(key) || key.startsWith("CONS_"))
                .map((key) => ({
                  title: key.startsWith("CONS_")
                    ? key.replace("CONS_", "")
                    : key,
                  dataIndex: key.startsWith("CONS_")
                    ? key.replace("CONS_", "")
                    : key,
                  key,
                  width: 150,
                  sorter: (a, b) => Number(a[key]) - Number(b[key]),
                  render: (value) => {
                    const numValue = parseFloat(value);
                    return isNaN(numValue) ? value : numValue.toFixed(2);
                  },
                })),
            ];

            setColumns(cols);
            setIsLoading(false);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
            setIsLoading(false);
          },
        });
      } catch (error) {
        console.error("Error fetching CSV:", error);
        setIsLoading(false);
      }
    };

    fetchCSVData();
  }, []);

  const handleRowClick = (acId) => {
    setSelectedACID(acId);
    setIsModalVisible(true);
  };

  return (
    <div className={title === "insight" ? "" : "page-wrapper"}>
      <div className="content container-fluid">
        <div className="elbow-curve-section">
          <div className="row">
            <div className="col-md-12">
              <div
                className="table-responsive"
                style={{ overflowX: "auto", maxHeight: "400px" }}
              >
                {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <Table
                    rowKey={(record) => record.CLUSTER}
                    scroll={{ y: 300, x: "max-content" }}
                    className="table-striped"
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalRecord,
                      onChange: (page) =>
                        setCurrentPage && setCurrentPage(page),
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <ClusterModal
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        acId={selectedACID}
      />
    </div>
  );
};

export default ClusterTable;
